import { render } from "./AboutCompany.vue?vue&type=template&id=28c72041&scoped=true&ts=true"
import script from "./AboutCompany.vue?vue&type=script&lang=ts"
export * from "./AboutCompany.vue?vue&type=script&lang=ts"

import "./AboutCompany.vue?vue&type=style&index=0&id=28c72041&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c72041"]])

export default __exports__